module.exports = __webpack_public_path__ + "static/media/about2.19983945.png";